var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .375C5.58.375.375 5.582.375 12 .375 18.422 5.58 23.625 12 23.625S23.625 18.422 23.625 12C23.625 5.582 18.42.375 12 .375m0 21A9.37 9.37 0 0 1 2.625 12 9.37 9.37 0 0 1 12 2.625 9.37 9.37 0 0 1 21.375 12 9.37 9.37 0 0 1 12 21.375m0-15.844a1.969 1.969 0 1 1 0 3.938 1.969 1.969 0 0 1 0-3.938m2.625 11.907c0 .31-.252.562-.562.562H9.936a.563.563 0 0 1-.562-.562v-1.125c0-.311.252-.563.563-.563h.562v-3h-.562a.563.563 0 0 1-.563-.562v-1.126c0-.31.252-.562.563-.562h3c.31 0 .562.252.562.563v4.687h.563c.31 0 .562.252.562.563z"
  })));
};
export default SvgInfoCircle;